(function () {
	angular
		.module('trackeye')
		.factory('Modal', _ModalFactory);

	_ModalFactory.$inject = ['$rootScope', '$http', '$templateCache', '$compile', '$document'];

	function _ModalFactory($rootScope, $http, $templateCache, $compile, $document) {

		function Modal(template, linked_scope) {
			this.template = template;
			this.element = angular.element('<div class="modal-container" />');
			this._linked_scope = linked_scope;

			this._compiled = false;
		}

		Modal.prototype.linkScope = function(scope) {
			this._linked_scope = scope;
		};

		Modal.prototype.open = function (data) {
			this._setScope(data);
			this._compileModal();
			this._append();
		};

		Modal.prototype.close = function() {
			this.element.remove();
			if (this.scope) {
				this.scope.$destroy();
			}
			this._destroyed = true;
		};

		Modal.prototype.getTemplateUrl = function() {
			return 'partials/modal/'+this.template+'.html';
		};

		Modal.prototype.setBody = function(element) {
			this.body = element;
		};

		Modal.prototype.isDestroyed = function () {
			return this._destroyed;
		};

		Modal.prototype.isCompiled = function () {
			return this._compiled;
		};

		Modal.prototype._append = function () {
			var body = $document.find('body');
			body.append(this.element);
		};

		Modal.prototype._compileModal = function () {
			$http.get(this.getTemplateUrl(), {cache: $templateCache}).then((function(xhr) {
				this.element.html(xhr.getResponseData());
				$compile(this.element)(this.scope);
				this._compiled = true;
			}).bind(this));
		};

		Modal.prototype._setScope = function(data) {
			var modal_scope = $rootScope.$new();

			if (data)
				modal_scope = angular.extend(modal_scope, data);

			modal_scope.close = (this.close).bind(this);

			if (this._linked_scope)
				modal_scope.vm = this._linked_scope;

			this.scope = modal_scope;
		};

		return Modal;
	}
})();